import { createSelector } from 'reselect';

const bootstrapSelector = ({ app = {} }) => {
    const { bootstrap = {} } = app;
    return bootstrap;
};

export default createSelector(bootstrapSelector, (bootstrap) => bootstrap);

export const espnPlayerSrcFilesSelector = createSelector(
    bootstrapSelector,
    (bootstrap) => {
        const { player = {} } = bootstrap;
        return {
            espnPlayerJsUrl: player['espn-web-player-js-url'],
            espnPlayerCssUrl: player['espn-web-player-css-url']
        };
    }
);



// WEBPACK FOOTER //
// ./app/common/selectors/bootstrapSelector.js